import { isWithinMinMaxRange } from '@impuls-coach/util-is';
import { isFloatMatch } from '@impuls-coach/util-is';
import { ValidationError } from 'components/hoc/withValidation';
import i18n from 'helper/i18n';
import { VALIDATE_IS_NOT_ALLOWED, VALIDATE_IS_NOT_RECOMMENDED } from 'helper/validator';

export const MIN_ALLOWED_HEIGHT = 60;
export const MAX_ALLOWED_HEIGHT = 230;

export const MIN_RECOMMENDED_HEIGHT = 130;
export const MAX_RECOMMENDED_HEIGHT = 215;

export default function heightValidatorFactory(input: string | number): Promise<ValidationError | undefined | void> {
	return new Promise<ValidationError | undefined | void>((resolve, reject) => {
		const toVerify: string = input.toString();

		if (toVerify === '') {
			resolve();
			return;
		}

		if (!isFloatMatch(toVerify)) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.anamnesis.determineHeight.invalidFormat'),
			});
		}

		const value = parseFloat(`${input}`);

		if (!isWithinMinMaxRange(value, MIN_ALLOWED_HEIGHT, MAX_ALLOWED_HEIGHT)) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.anamnesis.determineHeight.impossibleToTakePart'),
			});
			return;
		}

		if (!isWithinMinMaxRange(value, MIN_RECOMMENDED_HEIGHT, MAX_RECOMMENDED_HEIGHT)) {
			reject({
				type: VALIDATE_IS_NOT_RECOMMENDED,
			});
			return;
		}

		resolve();
	});
}
